import { AxiosError } from 'axios';

import StatusCodes from '@/v2/constants/StatusCodes';

const maxRetries = 3;

export default function saveRetryPolicy(failureCount: number, error: Error) {
  if (failureCount >= maxRetries) {
    return false;
  }

  const statusCode = (error as AxiosError).response?.status;

  return !statusCode || statusCode >= StatusCodes.INTERNAL_SERVER_ERROR;
}
